import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RawImage from 'components/RawImage';
import { loadProviderByID as loadProviderByIdAction } from 'redux/modules/tve';

const block = 'tve-provider';

const mapStateToProps = ({ shared, tve }) => ({
  hasTempPass: tve.hasTempPass,
  provider: tve.provider,
  selected: tve.selected,
  vertical: shared.vertical,
});

const mapDispatchToProps = (dispatch) => ({
  loadProviderById: (vertical, provider) => dispatch(loadProviderByIdAction(vertical, provider)),
});

class Logo extends React.Component {
  static propTypes = {
    loadProviderById: PropTypes.func.isRequired,
    hasTempPass: PropTypes.bool.isRequired,
    provider: PropTypes.string,
    selected: PropTypes.shape({
      logo2xWhite: PropTypes.string,
    }),
    vertical: PropTypes.string.isRequired,
  };

  static contextTypes = {
    store: PropTypes.shape({}),
  };

  static defaultProps = {
    provider: null,
    selected: null,
  };

  componentDidMount() {
    this.loadProvider();
  }

  componentDidUpdate({ provider: prevProv }) {
    const { provider: nextProv } = this.props;
    if (!prevProv && nextProv) {
      this.loadProvider();
    }
  }

  loadProvider = () => {
    const { vertical, provider, loadProviderById } = this.props;

    if (provider) {
      loadProviderById(vertical, provider);
    }
  }

  render() {
    const { hasTempPass, provider, selected } = this.props;
    if (hasTempPass || !provider) {
      return null;
    }
    if (selected && typeof selected.logo2xWhite !== 'undefined') {
      return (
        <div className={`${block}`}>
          <RawImage src={selected.logo2xWhite} />
        </div>
      );
    }
    return provider;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
